import styled from "styled-components";
import { getTextShadow } from "../../_themes/helpers";

export const Wrapper = styled.span`
  text-shadow: ${getTextShadow("displaysTitle", "displays.title")};
  font-size: 0.6em;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  display: block;
  white-space: nowrap;
  user-select: none;
`;
